import React from "react";
import { alpha, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { authContext } from "../../../configurations/adalConfig";
import SearchIcon from "@material-ui/icons/Search";
import AccountCircle from "@material-ui/icons/AccountCircle";
import StreamLogo from "../../../public/img/common/Stream-Data-Centers_Logo_WHITE.svg";
import "./TopNav.less";
import { parseJwt } from "../../../utils/generic";
import { NavLink } from "react-router-dom";
import { API_HEADERS } from "../../../constants/api";
import {
  GetUserConfiguration,
  IsSectionVisible,
  IsTenant,
  getTimeZone
} from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import ErrorPage from "../../../views/ErrorPage";
import MobileViewNav from "../SideNav/MobileViewNav";
import { isMobile, isTablet } from "react-device-detect";
import NotificationContainer from "./NotificationContainer";

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  search: {
    display: "none",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto"
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch"
    }
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  }
}));

export default function PrimarySearchAppBar() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  /** Profile menu popup open */
  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  /** Mobile menu popup Close */
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  /** Profile menu popup Close */
  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  /** Logout option */
  const handelLogOut = () => {
    authContext.logOut();
    localStorage.removeItem[API_HEADERS.authToken];
    window.location = "/";
  };

  // const handleMobileMenuOpen = event => {
  // 	setMobileMoreAnchorEl(event.currentTarget);
  // };

  const isAzureAd = localStorage.getItem("DCLT") === "/dc-user" ? true : false;

  const isUnAuthorized =
    localStorage.getItem("isUnAuthorized") == "true" ? true : false;

  let UserInitial = "NA";
  let UserName = "";
  let emailId = "";
  let group = "";
  if (localStorage.getItem("adal.idtoken")) {
    const getData = parseJwt(localStorage.getItem("adal.idtoken"));
    let CreateUserName = "";
    if (getData.given_name !== undefined) {
      CreateUserName =
        (getData.given_name || "") + " " + (getData.family_name || "");
    } else if (getData.UserName !== undefined) {
      CreateUserName = getData.UserName;
    }
    UserName = CreateUserName;
    if (UserName !== "" || UserName !== "") {
      const matches = UserName.match(/\b(\w)/g);
      UserInitial = matches.join("");
    } else {
      UserInitial = "";
    }

    emailId = getData.email;
  }
  const user = GetUserConfiguration();
  group = ((user.groups || [])[0] || {}).description;
  const contactType = (user.userInfo || {}).userType;
  if (contactType && contactType == "Admin") {
    group = group + " Admin";
  }

  const timezone = getTimeZone();

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      style={{ marginTop: "30px" }}
    >
      <div className={"user-initial-inner"}>{UserInitial}</div>
      {UserName && <div className={"user-details-inner"}>{UserName}</div>}
      <div className={"user-details-inner"}>{emailId}</div>
      <div className={"user-details-inner"}>{group}</div>
      <div className={"user-details-inner"}>
        {"Timezone: "}
        {timezone}
      </div>
      <MenuItem
        onClick={(handleMenuClose, handelLogOut)}
        style={{ paddingLeft: "35%" }}
      >
        {"Sign Out\r"}
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label={"show 4 new mails"} color={"inherit"}>
          {/* <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge> */}
        </IconButton>
        <p>{"Notifications"}</p>
      </MenuItem>
      {/* <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem> */}
      <MenuItem onClick={handleProfileMenuOpen}>
        {"Hi\r"}
        <IconButton
          aria-label={"account of current user"}
          aria-controls={"primary-search-account-menu"}
          aria-haspopup={"true"}
          color={"inherit"}
        >
          <AccountCircle />
        </IconButton>
        <p>{"Sign Out"}</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      {isUnAuthorized == true && isAzureAd ? (
        <div>
          <ErrorPage
            emailId={emailId}
            isUnauthorized
            details={{
              errorCode: 403,
              message: "",
              heading: "You need permission to access this application.",
              goToHomeEnabled: false
            }}
          />
        </div>
      ) : (
        <>
          <div className={classes.grow}>
            <AppBar position={"static"} className={"appbar-background"}>
              <Toolbar>
                {/* <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton> */}
                <NavLink
                  to={
                    IsSectionVisible(SECTIONS.WELCOME) ? "/welcome" : IsSectionVisible(SECTIONS.DASHBOARD) ? "/Dashboard" : IsSectionVisible(SECTIONS.SDC_GRANT_ACCESS) ? "/SDCGrantAccess" :  IsSectionVisible(SECTIONS.TENANT) ? "/tenant" :  "/kpi" 
                  }
                >
                  <img
                    src={StreamLogo}
                    alt={"logo"}
                    className={"stream-logo"}
                  />
                </NavLink>
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                </div>
                {isMobile === true || isTablet === true ? (
                  <></>
                ) : (
                  <div
                    className={classes.grow}
                    style={{
                      fontSize: "18px",
                      textAlign: "center",
                      textTransform: "uppercase",
                      fontWeight: "500"
                    }}
                  >
                    {"Data Center Operations Portal\r"}
                  </div>
                )}
                {!IsTenant() && <NotificationContainer />}
                <div className={classes.sectionDesktop}>
                  <div>
                    <IconButton
                      edge={"end"}
                      aria-label={"User Profile"}
                      aria-controls={menuId}
                      aria-haspopup={"true"}
                      onClick={handleProfileMenuOpen}
                      color={"inherit"}
                      size={"medium"}
                      className={"iconButton-extend"}
                    >
                      <span className={"user-initial"}>{UserInitial}</span>
                    </IconButton>
                  </div>
                </div>

                {isMobile === true || isTablet === true ? (
                  <MobileViewNav
                    type={"mobile"}
                    topInitial={
                      <IconButton
                        edge={"end"}
                        aria-label={"User Profile"}
                        aria-controls={menuId}
                        aria-haspopup={"true"}
                        onClick={handleProfileMenuOpen}
                        color={"inherit"}
                        size={"medium"}
                        className={"iconButton-extend"}
                      >
                        <span className={"user-initial"}>{UserInitial}</span>
                      </IconButton>
                    }
                  />
                ) : (
                  <></>
                )}
              </Toolbar>
            </AppBar>
            {renderMobileMenu}
            {renderMenu}
          </div>
        </>
      )}
    </>
  );
}
